export default "__VITE_ASSET__o$49Sz75__"